<kendo-fileselect #fileSelectAttachDocs zoneId="myZone" (select)="onSelect($event)" (remove)="onRemove($event)"
     [showFileList]="true" [disabled]="isDisabled" [restrictions]="fileRestrictions">
</kendo-fileselect>

